/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Warning_TitleInputs */



/**
* | output |
* | --- |
* | "Use a separate audio source." |
*
* @param {Live_Caption_Youtube_Warning_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_warning_title = /** @type {((inputs?: Live_Caption_Youtube_Warning_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Warning_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisez une source audio distincte.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwenden Sie eine separate Audioquelle.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utilizzare una sorgente audio separata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Используйте отдельный источник звука.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Utilice una fuente de audio independiente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用单独的音频源。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("別の音声ソースを使用してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("किसी अलग ऑडियो स्रोत का उपयोग करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Utilize uma fonte de áudio separada.")
	return /** @type {LocalizedString} */ ("Use a separate audio source.")
});